<template>
  <div v-loading="initLoading">
  <div class="ReportDetailPage" style="padding: 20px;width: 500px;background-color: #fafafa">
    <div style="font-size: 20px">
      <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
        <el-breadcrumb-item :to="{ path: '/console' }">数据中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/RuleReview' }">提成规则审核</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="font-size: 25px;margin-top: 15px;">
      <p>提成规则审核 </p>
    </div>
    <div style="width: 500px; font-family: 宋体; font-size: 25px;font-weight: bold">
      <el-form :model="ruleForm" multiple status-icon :rules="rules" ref="ruleForm" label-width="100px"
               style=" margin-top: 30px;width: 300px">
        <el-form-item label="申报时间" style="width: 500px">
          <el-col :span="11">
            <el-date-picker
              v-model="ruleForm.startDate"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="开始日期"
              :picker-options="startDate" style="width: 100%;">
            </el-date-picker>
          </el-col>
          <el-col class="line" :span="2">&nbsp;</el-col>
          <el-col :span="11">
            <el-date-picker
              v-model="ruleForm.endDate"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="结束日期"
              :picker-options="endDate" style="width: 100%;">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="供应商" prop="selectedSupplierIds">
          <el-select popper-class="el-select" v-model="ruleForm.selectedSupplierIds" v-if="user!=[]" value-key="id"
                     multiple placeholder="请选择供应商" @change="supplierid()" style="width: 400px">
            <select-all-option v-model="ruleForm.selectedSupplierIds" @change="supplierid" :data="user" :autoSelect="true"/>
            <el-option
              v-for="item in user"
              :key="item.id"
              :label="item.name"
              :value='item'
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="品牌" prop="selectParentBrands">
          <el-select clearable v-model="ruleForm.selectedParentBrands" popper-class="el-select" multiple
                     placeholder="请选择品牌" style="width: 400px;color: #EF6C00" value-key="id"
                     :disabled="ruleForm.selectedSupplierIds.length == 0">
            <!--          <el-select clearable v-model="ruleForm.selectedParentBrands" popper-class="el-select" multiple placeholder="请选择品牌" style="width: 400px;color: #EF6C00" value-key="id"  @change="selectParentBrandss" :disabled="ruleForm.selectedSupplierIds.length == 0" >-->
            <!--            <select-all-option @change="selectParentBrandss" v-model="ruleForm.selectedParentBrands" group-value="brands" :data="dataInfos"/>-->
            <select-all-option v-model="ruleForm.selectedParentBrands" group-value="brands" :data="dataInfos"/>
            <el-option-group
              v-for="group in dataInfos"
              :key="group.id"
              :label="group.name" style="white-space: pre-wrap">
              <el-option
                v-for="item in group.brands"
                :key="item.id"
                :label="item.parentBrand"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>

        <el-form-item label="区域" prop="selectRegionals">
          <el-select popper-class="el-select" v-model.number="ruleForm.selectedRegionals" multiple style="width: 400px"
                     value-key="id" @change="selectRegionalss" placeholder="请选择区域"
                     :disabled="ruleForm.selectedSupplierIds.length == 0">
            <select-all-option v-model="ruleForm.selectedRegionals" group-value="regionals" @change="selectRegionalss"
                               :data="selectRegionals"/>
            <el-option-group
              v-for="group in selectRegionals"
              :key="group.name"
              :label="group.name">
              <el-option
                v-for="item in group.regionals"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="省份" prop="selectProvinces">
          <el-select popper-class="el-select" v-model.number="ruleForm.selectedProvinces" style="width: 400px"
                     value-key="id" multiple placeholder="请选择省份">
            <select-all-option v-model="ruleForm.selectedProvinces" group-value="children" @change="selectRegionalss"
                               :data="selectProvinces"/>
            <el-option-group
              v-for="group in selectProvinces"
              :key="group.name"
              :label="group.name">
              <el-option
                v-for="item in group.children"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>

        <el-form-item label="审核状态">
          <el-select popper-class="el-select" v-model="form.select"
                     style="width: 400px">
            <el-option v-for="item in options" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="导出条件">
          <el-select popper-class="el-select" v-model="form.source" multiple
                     style="width: 400px">
            <select-all-option v-model="form.source" :data="sources"/>
            <el-option v-for="item in sources" :key="item.value" :label="item.label" :value="item"></el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <el-row style="margin-left: 100px;text-align: center">
        <el-col :span="12">
          <el-button style="color: white; border-color: #FF6633; background-color: #FF6633" :loading="loading1"
                     @click="download">导出审核表格
          </el-button>
        </el-col>
        <el-col :span="12">
          <el-button style="color: white; border-color: #FF6633; background-color: #FF6633" :loading="loading2"
                     @click="uploadResult" :disabled="dashboardSales">上传审核结果
          </el-button>
          <input type="file" ref="uploadResult" v-show="false" accept=".xls,.xlsx" @change="upLoadExcel"/>
        </el-col>
      </el-row>
    </div>
  </div>
  </div>
</template>

<script>
import {allUser, reviewExcel, putExcel} from '@/api/RuleReview'
import selectAllOption from "@/components/selectAllOption";


export default {
  components: {selectAllOption},
  data() {
    return {
      // 判断时间的限制
      startDate: {
        disabledDate: (time) => {
          if (this.ruleForm.endDate) {
            return time.getTime() > new Date(this.ruleForm.endDate).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endDate: {
        disabledDate: (time) => {
          if (this.ruleForm.startDate) {
            return (time.getTime() < new Date(this.ruleForm.startDate).getTime() || time.getTime() > Date.now())
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      ruleForm: {
        selectedSupplierIds: '',
        endDate: this.getNowTime(),
        startDate: this.getStartTime(),
        selectedParentBrands: [],
        selectedRegionals: [],
        selectedProvinces: [],
        status: '',
        source:''
      },
      options: [{
        value: '3',
        label: '全部'
      }, {
        value: '1',
        label: '已通过'
      }, {
        value: '2',
        label: '已拒绝'
      }, {
        value: '0',
        label: '待审核'
      }],
      sources:[{
        value: 2,
        label:'通路管理助手'
      },{
        value: 1,
        label:'数据中心web'
      }],
      form: {
        select: '0',
        source: []
      },
      rules: {
        selectedSupplierIds: [
          {required: true, message: '请至少选择一个供应商', trigger: 'change'}
        ]
      },
      user: [],
      value: '',
      selectParentBrands: [{brands: []}],
      selectBrands: [],
      selectProducts: [],
      selectRegionals: [],
      selectProvinces: [],
      token: '',
      supplierId: '',
      selectedSupplierId: [],
      dataInfos: [],
      loading1: false,
      loading2: false,
      dialogFormVisible: false,
      dashboardSales:false,
      initLoading:true
    }
  },

  created() {
    this.dashboardSales = localStorage.getItem('dashboardSales') == 2 ? true : false
    this.token = localStorage.getItem('token')
    this.$store.commit('addTips', ['具备直接调整导购规则权限的调整申请将自动通过，而不具备直接调整权限的调整申请都将反映在此处，您可根据公司提成政策进行相应的审核操作。',
      '请在审核结果列填写：审核通过 或 审核拒绝（留空代表待定，您可以延后进行处理）'])
    allUser(this.token).then(res => {
      if (res.data.suppliers != null) {
        this.user = res.data.suppliers
      }
      this.initLoading = false
    }).catch(error => {
      let status = error.response.status;
      if (status == 500) {
        this.$notify.error({
          title: '错误',
          message: '查询失败，请联系管理员',
          position: 'bottom-right'
        })
      }
    })
  },
  methods: {
    supplierids(lists) {
      // 合并数组对象中key相同的数据
      let dataInfo = []
      let dataInfos = []
      lists.forEach((item1, index) => {
        let data = {
          id: index,
          name: item1.name,
          brands: []
        }
        let data1 = {
          id: index + ".",
          name: item1.name,
          brands: []
        }
        let countSame = []
        item1.brands.forEach((item, index) => {
          let {parentBrand} = item
          dataInfo.forEach(a1 => {
            a1.brands.forEach(b1 => {
              // 当不同供应商底下品牌相同的情况下
              if (parentBrand === b1.parentBrand) {
                // 保存相同品牌数据
                countSame.push(parentBrand)
              }
            })
          })
          if (!data.brands[parentBrand]) {
            data.brands[parentBrand] = {
              id: item.id,
              parentBrand: item.parentBrand,
              brand: [{
                id: item.pid,
                name: item.name,
                products: item.products
              }]
            }
          } else if (data.brands[parentBrand]) {
            data.brands[parentBrand].brand.push({
              id: item.pid,
              name: item.name,
              products: item.products
            })
          }
        })
        let list = Object.values(data.brands)
        data.brands = list
        dataInfo.push(data)
        // 构造一个相同的
        const res2 = new Map();
        countSame = countSame.filter((co) => !res2.has(co) && res2.set(co, 1))
        if (countSame.length > 0) {
          countSame.forEach(cs => {
            var names = ""
            let parentBrands = []
            dataInfo.forEach((a, indexs) => {
              a.brands.forEach((b, index) => {
                if (b.parentBrand === cs) {
                  if (names.substr(names.length - 1, 3) === "\n") {
                    names += a.name
                  } else {
                    names += a.name + "\n"
                  }
                  if (!data1.brands[b.parentBrand]) {
                    data1.brands[b.parentBrand] = {
                      id: b.id,
                      parentBrand: b.parentBrand,
                      brand: b.brand
                    }
                  } else {
                    b.brand.forEach(brand => {
                      data1.brands[b.parentBrand].brand.push({
                        id: brand.id,
                        name: brand.name,
                        products: brand.products
                      })
                    })
                    // 去重
                    const res = new Map();
                    data1.brands[b.parentBrand].brand = data1.brands[b.parentBrand].brand.filter((f) => !res.has(f.name) && res.set(f.name, 1))
                  }
                  a.brands.splice(index, 1)
                }
                if (data1.brands[b.parentBrand] !== undefined) {
                  parentBrands[b.parentBrand] = data1.brands[b.parentBrand]
                }
              })
            })
            if (names !== null && parentBrands[cs] !== undefined) {
              let lists = Object.values(parentBrands)
              if (lists.length !== 0) {
                data1.brands = lists
                data1.name = names
                dataInfo.push(data1)
                dataInfo = JSON.parse(JSON.stringify(dataInfo))
              }
            }
          })
        }
      })
      // 过滤掉品牌为空的
      dataInfo.forEach(da => {
        if (da.brands.length !== 0) {
          let datas = {
            id: da.id,
            name: da.name,
            brands: da.brands
          }
          dataInfos.push(datas)
        }
      })
      dataInfos.forEach((das, index) => {
        if (das.name.indexOf("\n") !== -1) {
          dataInfos.unshift(dataInfos.splice(index, 1)[0])
        }
      })
      this.dataInfos = dataInfos
    },
    supplierid() {
      if (this.ruleForm.selectedSupplierIds != '') {
        this.selectParentBrands = this.ruleForm.selectedSupplierIds
        this.supplierids(this.selectParentBrands)
        this.selectRegionals = this.ruleForm.selectedSupplierIds
        let parentBrands = [];
        if (this.ruleForm.selectedParentBrands != '') {
          this.ruleForm.selectedParentBrands.forEach((item, index) => {
            this.selectParentBrands.forEach((e, i) => {
              e.brands.forEach((t, m) => {
                if (item.parentBrand == t.parentBrand) {
                  parentBrands[item.parentBrand] = item
                }
              })
            })
          })
          this.ruleForm.selectedParentBrands = Object.values(parentBrands);
        }
      } else {
        this.ruleForm.selectedParentBrands = []
        this.ruleForm.selectedRegionals = []
        this.ruleForm.selectedProvinces = []
      }
    },
    selectRegionalss() {
      if (this.ruleForm.selectedRegionals != '' && this.ruleForm.selectedRegionals.length > 0) {
        this.selectProvinces = this.ruleForm.selectedRegionals
      } else {
        this.ruleForm.selectedProvinces = []
      }
    },
    download() {
      this.ruleForm.source = this.form.source
      this.ruleForm.status = this.form.select
      if (this.ruleForm.selectedSupplierIds != '') {
        this.token = localStorage.getItem('token')
        this.loading1 = true
        reviewExcel(this.token, this.ruleForm).then(res => {
          if (res !== null) {
            this.$notify.success({
              type: 'success',
              message: '导出成功',
              title: '成功',
              position: 'bottom-right'
            })
            this.handleDownload(res)
            this.loading1 = false
          } else {
            this.$notify({
              type: 'error',
              message: '导出失败',
              title: '失败',
              position: 'bottom-right'
            })
            this.loading = false
          }
        }).catch(error => {
          let status = error.response.status;
          if (status == 500) {
            this.$notify.error({
              type: 'error',
              title: '错误',
              message: '导出失败，请联系管理员',
              position: 'bottom-right'
            })
          }
        }).finally(() => {
          this.loading1 = false
        })
      } else {
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
      }
    },
    handleDownload(res) {
      let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const fileName = decodeURI(res.headers['filename'])
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    uploadResult() {
      if (this.ruleForm.selectedSupplierIds.length < 1) {
        this.$notify({
          title: '警告',
          message: '请选择至少一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
        return
      }
      this.supplierId = this.ruleForm.selectedSupplierIds[0].id
      this.$refs.uploadResult.click()
    },
    upLoadExcel() {
      this.loading2 = true
      let inputDOM = this.$refs.uploadResult
      let file = inputDOM.files[0]
      let formData = new FormData();
      formData.append("file", file)
      putExcel(this.token, this.supplierId, formData).then(r => {
        let {data} = r
        if (data.code == 200)
          this.successMsg = data.date
        this.$notify.success({
          title: '成功',
          message: data.msg,
          position: 'bottom-right'
        })
        if (data.code == 1)
          this.$notify.error({
            title: '错误',
            message: data.msg,
            position: 'bottom-right'
          })
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '审核失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.loading2 = false
        this.$refs.upload.value = ''
      })
    },
    getNowTime() {
      let now = new Date()
      let year = now.getFullYear() // 得到年份
      let month = now.getMonth() // 得到月份
      let date = now.getDate() // 得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')
      var defaultDate = `${year}-${month}-${date}`
      return defaultDate
    },
    getStartTime() {
      let now = new Date()
      now = new Date(now.getTime() - 3600 * 1000 * 24 * 7);
      now.setMonth(now.getMonth());
      let year = now.getFullYear() // 得到年份
      let month = now.getMonth() // 得到月份
      let date = now.getDate() // 得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')
      let defaultDate = `${year}-${month}-${date}`
      return defaultDate
    }
  }
}
</script>

<style soped>
.el-select .el-input.is-focus .el-input__inner {
  border-color: #EF6C00;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: #EF6C00
}

.el-select .el-select-dropdown__list {
  list-style: none;
  padding: 0px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

</style>
